import { render, staticRenderFns } from "./whiteList.vue?vue&type=template&id=2b405928&scoped=true"
import script from "./whiteList.vue?vue&type=script&lang=ts"
export * from "./whiteList.vue?vue&type=script&lang=ts"
import style0 from "./whiteList.vue?vue&type=style&index=0&id=2b405928&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b405928",
  null
  
)

export default component.exports